'use client'

import ArticlesModal from './ArticlesModal'
import SideHeadlines from './SideHeadlines'
import StorySides, { WhatHappened } from './StoryFormat'
import { useTopicContext } from './TopicContext'

// The story page's body, one shape for every story (2026-11-01): "What
// happened" in a 760px reading column, the two sides when the story has a
// both-sides page, then "Read the coverage" in the outlets' own words.
//
// Stories from before the both-sides pages (2026-09-13) have no sides to
// show, so they get the same page without that section: their summary under
// "What happened", then the coverage. The older layout they used to get (the
// reporting panel, the analysis-and-opinion angles, the amber type legend
// and the day-by-day flipper) was retired with the concept build.
export default function TopicContent({
  topic,
  mainStory,
  afterSides = null,
  sidesFooter = null,
  updatedLabel = null,
}) {
  const { topicSlug } = useTopicContext()
  const sf = topic.story_format
  const summary = sf?.what_happened || topic.facts || mainStory?.summary || null

  return (
    <div className="flex flex-col gap-6">
      <main className="min-w-0 flex-1">
        {/* The mocks' page: "What happened" under a small-caps heading,
            ruled in ink above on a desktop; the two sides and the coverage
            run the frame's full width under it. */}
        {summary && (
          <section className="mx-auto mt-[22px] max-w-[760px] sm:mt-10 sm:border-t sm:border-foreground sm:pt-[26px]">
            <div className="mb-2 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 sm:mb-3">
              <h2 className="panel-eyebrow text-[11px] sm:text-xs">
                What happened
              </h2>
              {/* When the story last moved, at the start of the facts it
                  describes (2026-10-24). */}
              {updatedLabel && (
                <span className="font-sans text-xs text-muted-foreground">
                  Updated {updatedLabel} ET
                </span>
              )}
            </div>
            <WhatHappened
              text={summary}
              bullets={sf?.bullets}
              topics={topic.topic_links}
            />
          </section>
        )}
        {sf && (
          /* No heading of its own (the mocks): the ruled box and its two
             coloured labels are the section. */
          <section className="mt-[26px] sm:mt-11">
            <StorySides
              storyFormat={sf}
              articles={topic.articles}
              topicSlug={topicSlug}
            />
            {/* The share line, where the page has just shown what it's
                for (2026-10-25). */}
            {sidesFooter && <div className="mt-5">{sidesFooter}</div>}
          </section>
        )}
        {afterSides}
        {/* The evidence for the sides above, in the outlets' own words.
            After the prose, not before it: the characterisation earns its
            keep by being checkable, which only works once it's been read. */}
        <SideHeadlines
          articles={topic.articles}
          storyFormat={sf}
          topicSlug={topicSlug}
        />
      </main>

      {/* Mobile Articles Modal */}
      <ArticlesModal />
    </div>
  )
}
